import { render } from "./LandingPage.vue?vue&type=template&id=92a0a434&scoped=true&ts=true"
import script from "./LandingPage.vue?vue&type=script&lang=ts"
export * from "./LandingPage.vue?vue&type=script&lang=ts"

import "./LandingPage.vue?vue&type=style&index=0&id=92a0a434&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92a0a434"]])

export default __exports__